import { shortAddr } from "../lib/address";
import type { VenueExecutor } from "../lib/api";
import { venueExecutor } from "../lib/venueExecutors";

/** A row's executor, short, with "Retired" when its release is; "—" when the row names none. */
export function ExecutorCell({ address, venue }: { address: string | null; venue: readonly VenueExecutor[] | null }) {
  if (address === null) return <span className="mk-executor-none">—</span>;
  const known = venueExecutor(venue, address);
  return (
    <span className="mk-executor">
      <span className="mk-mono" title={address}>
        {shortAddr(address)}
      </span>
      {known !== null && !known.fillable && <span className="mk-retired">Retired</span>}
    </span>
  );
}
